import { render, staticRenderFns } from "./noCode.vue?vue&type=template&id=b569eb7e&scoped=true"
import script from "./noCode.vue?vue&type=script&lang=ts"
export * from "./noCode.vue?vue&type=script&lang=ts"
import style0 from "./noCode.vue?vue&type=style&index=0&id=b569eb7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b569eb7e",
  null
  
)

export default component.exports